// Pending AppSumo redemption, parked in localStorage between landing on
// /appsumo (usually logged out) and activating after signup/login. The claim
// token is a short-lived signed JWT minted by the backend — the raw OAuth
// code is single-use and can't survive the auth round-trip.

const STORAGE_KEY = 'appsumo_claim'

export type AppsumoClaim = {
  claimToken: string
  plan: string
}

export const getAppsumoClaim = (): AppsumoClaim | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as AppsumoClaim
    return parsed.claimToken ? parsed : null
  } catch {
    return null
  }
}

export const setAppsumoClaim = (claim: AppsumoClaim) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(claim))
}

export const clearAppsumoClaim = () => {
  localStorage.removeItem(STORAGE_KEY)
}
